module.exports = __webpack_public_path__ + "static/media/fn_intro.e483bb63.png";